import React from 'react';
import Modal from 'react-modal';
import {LoadingPage} from 'components/loading-page';
import style from './style.scss';

class TermsOfUse extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isLoadingPopup: false,
      isOpen: false
    }
  }

  openModal() {
    document.body.classList.add("term-open");
    this.setState({
      isOpen: true,
      isLoadingPopup: true
    }, () => {
      // giả lập có loading
      setTimeout(() => {
        this.setState({isLoadingPopup: false})
      }, 2000);
    })
  }

  closeModal() {
    document.body.classList.remove("term-open");
    this.setState({isOpen: false, isLoadingPopup: false})
  }

  render() {
    const styles = {
      content: {
        top: '0',
        left: '0',
        right: '0',
        bottom: '0'
      }
    };
    return (
      <span className="terms-of-use" onClick={this.openModal.bind(this)}>
        &nbsp;điều kiện sử dụng và chính sách của KontumTrade
        <Modal isOpen={this.state.isOpen} onRequestClose={this.closeModal.bind(this)} style={styles} className="terms-of-use-container">
          <LoadingPage isShow={this.state.isLoadingPopup}/> {this.state.isLoadingPopup
            ? null
            : (
              <div className='center'>
                <div className='term-popup-content-wrap'>
                  <button className='btn-close-term' onClick={this.closeModal.bind(this)}>X</button>
                  <div className='term-popup-content'>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>
                    this is content
                    <br/>

                  </div>
                </div>
              </div>
            )
}
        </Modal>
      </span>
    );
  }
}

export default TermsOfUse;



// WEBPACK FOOTER //
// ./components/partials/terms-of-use/TermsOfUse.jsx